import { useEffect, useState } from 'react';

import { useUploadElevationCertificateMutation } from '../services/api';
import { errorToast, successToast } from '../utils/toast';
import BaseFloodElevationModal from './BaseFloodElevationModal';
import { Button, LinkLikeButton } from './general/Button';

const BaseFloodElevationBox = ({
  baseFloodElevation = null,
  firstFloorElevation = null,
  propertyId = null,
  coordinates = null,
  ecFlag = null,
  reportPage = false,
}) => {
  const [isBfeModalOpen, setIsBfeModalOpen] = useState(false);
  const canManuallyEditBfe = !reportPage;

  const [uploadElevationCertificate, { isSuccess, isError }] =
    useUploadElevationCertificateMutation();

  useEffect(() => {
    if (isSuccess) {
      successToast('Elevation certificate uploaded successfully!');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      errorToast('Elevation certificate upload failed. Please try again later.');
    }
  }, [isError]);

  // Only the certificate is persisted; the modal's elevation inputs are preview-only.
  const saveFloodElevationChanges = ({ certificateFileInfo }) => {
    if (certificateFileInfo) {
      uploadElevationCertificate({ fileData: certificateFileInfo, coordinates });
    }
  };

  return (
    <>
      <div className="border-b border-fossil bg-white px-2 py-3 text-left">
        {canManuallyEditBfe && (
          <div className="mb-2 flex flex-col items-center justify-center gap-2">
            <Button className="!mt-0 !px-4 !py-2 text-base" onClick={() => setIsBfeModalOpen(true)}>
              Enter Base Elevation
            </Button>
            <LinkLikeButton onClick={() => setIsBfeModalOpen(true)}>
              Upload Finished Floor Elevation (FFE)
            </LinkLikeButton>
          </div>
        )}
      </div>
      {canManuallyEditBfe && (
        <BaseFloodElevationModal
          isOpen={isBfeModalOpen}
          onClose={() => setIsBfeModalOpen(false)}
          initialValue={baseFloodElevation}
          firstFloorElevation={firstFloorElevation}
          ecFlag={ecFlag}
          onSave={saveFloodElevationChanges}
        />
      )}
    </>
  );
};

export default BaseFloodElevationBox;
